import { RepositoriesList } from "../Components/Repositories";

const Repositorios = () => {
  return <RepositoriesList />;
};

export default Repositorios;
